import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ToggleCheckbox} from "./toggle-checkbox";
import {AppState} from "../../store";
import {Store} from "@ngrx/store";
import {setJobFilter, setUpdateArchiveView} from "../../store/actions/filter.actions";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-toggle-checkbox',
  templateUrl: './toggle-checkbox.component.html',
  styleUrls: ['./toggle-checkbox.component.scss']
})
export class ToggleCheckboxComponent {
  @Input('data') set setData(val: ToggleCheckbox) {
    if(val) {
      this.data = val;
      this.store.select(getFilterByKey(this.data.filterKey)).pipe(untilDestroyed(this)).subscribe((val) => {
        this.isSelected = val;
      })

    }
  };

  @Input('numberLabel') numberLabel: number | null = null;

  @Input('initialValue') set setInitialValue(val: boolean) { // case if no store used
    this.isSelected = val;
  }

  @Output('state-changed') stateChanged = new EventEmitter<boolean>();

  data!: ToggleCheckbox;
  isSelected = false;

  constructor(private store: Store<AppState>) {
  }

  toggleState() {
    this.isSelected = !this.isSelected;
    this.stateChanged.emit(this.isSelected);
    this.store.dispatch(setJobFilter({key: this.data.filterKey, value: this.isSelected}));
  }
}
